<!--
   Created by qing on 2020/4/22 9:09 下午
   Des: 推荐应用
-->
<template>
  <div class="recommend-container">
    <div class="header">
      <van-button type="primary" size="small" @click="onClickInstall">
        立即安装({{selectedTemp.length}})
      </van-button>
      <p class="sub" @click="onClickCancel">我不需要</p>
    </div>
    <div class="template-container">
      <van-checkbox-group v-model="selectedTemp">
        <div
          class="template-item"
          v-for="item in tempList"
          :key="item.appId">
          <div
            class="title-container"
            @click="onClickPreview(item)">
            <img :src="item.appImg" alt="">
            <div class="temp-info">
              <p class="title">{{item.appName}}</p>
              <p class="install">已有{{item.installCount}}个团队安装</p>
            </div>
          </div>
          <van-checkbox :name="item.appId" checked-color="#07c160"></van-checkbox>
        </div>
      </van-checkbox-group>
    </div>

    <van-action-sheet
      v-model="visible"
      :actions="opts"
      title="是否需要保留示例数据"
      cancel-text="取消"
      @select="onSelect">
    </van-action-sheet>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        selectedTemp: [],
        tempList: [],

        visible: false,
        opts: [
          {
            name: '保留示例数据',
            value: 1,
            // color: 'transparent'
          },
          {
            name: '不保留示例数据',
            value: 0,
            // color: 'transparent'
          },
        ],
      };
    },
    created() {

      this.$store.dispatch('actionRecommendTemplate', {
        tagId: this.$route.query.tagId
      })
        .then(res => {
          this.tempList = res
          this.selectedTemp = res.map(item => item.appId)
        }).catch(console.error)
    },
    methods: {
      onClickInstall() {
        if (this.selectedTemp.length) {
          this.visible = true
        }
      },
      // 选择数据后安装应用
      onSelect(item) {
        if (this.$store.getters.userInfo) {
          // 登陆过
          let tempList = []
          this.selectedTemp.forEach(appId => {
            const temp = this.tempList.filter(temp => temp.appId === appId)[0]
            if (temp) {
              tempList.push({
                tempId: temp.appId,
                tempName: temp.appName
              })
            }
          })
          this.$store.dispatch('actionNodeSave', {
            tempList,
            userInfo: this.$store.getters.userInfo,
            companyInfo: this.$store.getters.company,
            installData: item.value
          }).then(res => {
            // 跳转到小程序安装应用页面
            this.$wx.miniProgram.redirectTo({url: `/pages/install_temp/index?key=${res.nodeKey}`})
          }).catch(console.error)

        } else {
          // 未登陆
          this.$toast.fail('未获取到登陆信息')
          // this.$wx.miniProgram.redirectTo({url: `/pages/temp_center_login/index?tempId=${this.tempInfo.appId}`})
        }
      },
      onClickCancel() {
        this.$wx.miniProgram.postMessage({
          data: {
            company: this.$store.getters.company
          }
        })
        this.$wx.miniProgram.navigateBack()
      },
      onClickPreview(temp) {

        this.$store.dispatch('actionNodeSave', {
          userId: this.$store.getters.userId,
          userInfo: this.$store.getters.userInfo,
          company: this.$store.getters.company,
          tempId: temp.appId,
        }).then(res => {

          this.$router.push({
            name: 'tempPreview',
            query: {
              key: res.nodeKey
            }
          })
        }).catch(console.error)
      }
    }
  };
</script>

<style lang="less">

  .recommend-container {
    background-color: #fff;
    height: calc(100% - env(safe-area-inset-bottom));
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 20px 20px 0 20px;
      padding-bottom: 10px;
      border-bottom: 1px solid #e6e6e6;

      .sub {
        color: #959699;
        font-size: 14px;
      }
    }

    .template-container {
      padding: 20px;

      .template-item {
        display: flex;
        width: 100%;
        height: 60px;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        border-bottom: 1px solid #e6e6e6;

        .title-container {
          flex: 1;
          display: flex;

          img {
            height: 50px;
            width: 50px;
            object-fit: cover;
            margin-right: 10px;
          }

          .temp-info {
            flex: 1;
            position: relative;

            .title {
              width: 100%;
              position: absolute;
              font-size: 18px;
              margin-bottom: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .install {
              position: absolute;
              width: 100%;
              margin-top: 30px;
              color: #959699;
              font-size: 12px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        .van-checkbox {
          margin-right: 10px;
        }

      }
    }
  }

</style>